import React, { useState } from 'react';
import axios from 'axios';
import './AccountContact.css';
import { API_URL } from '../config/data';
import { logout, checkAuth } from '../utils/auth';

const AccountContact = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    phone: '',
    email: ''
  });
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    
    // Очищаем ошибку при изменении поля
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
    
    // Очищаем сообщение об успехе
    if (successMessage) {
      setSuccessMessage('');
    }
  };

  const handlePhoneChange = (e) => {
    let value = e.target.value;
    
    // Удаляем все нецифровые символы
    const digitsOnly = value.replace(/\D/g, '');
    
    // Ограничиваем длину для российского номера (10 цифр)
    const limitedDigits = digitsOnly.slice(0, 10);
    
    // Применяем российскую маску: 999 999 99 99
    if (limitedDigits.length > 0) {
      value = limitedDigits.replace(/(\d{3})(\d{0,3})(\d{0,2})(\d{0,2})/, (match, p1, p2, p3, p4) => {
        let result = p1;
        if (p2) result += ` ${p2}`;
        if (p3) result += ` ${p3}`;
        if (p4) result += ` ${p4}`;
        return result;
      });
    } else {
      value = '';
    }
    
    setFormData(prev => ({
      ...prev,
      phone: value
    }));
    
    if (errors.phone) {
      setErrors(prev => ({
        ...prev,
        phone: ''
      }));
    }
    
    if (successMessage) {
      setSuccessMessage('');
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.fullName.trim()) {
      newErrors.fullName = 'Введите ФИО';
    }

    if (!formData.phone.trim()) {
      newErrors.phone = 'Введите номер телефона';
    } else {
      const phoneDigits = formData.phone.replace(/\D/g, '');
      if (phoneDigits.length < 10) {
        newErrors.phone = 'Введите полный номер телефона';
      }
    }

    if (!formData.email.trim()) {
      newErrors.email = 'Введите email';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = 'Введите корректный email';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleCallback = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }

    setIsLoading(true);
    setErrors({});
    setSuccessMessage('');

    try {
      const response = await axios.post(`${API_URL}/api/contact/callback`, {
        fullName: formData.fullName.trim(),
        phone: formData.phone.trim(),
        email: formData.email.trim()
      }, {
        headers: {
          'Content-Type': 'application/json'
        }
      });

      if (response.status === 200) {
        setSuccessMessage('Заявка успешно отправлена! Мы свяжемся с вами в ближайшее время.');
        setFormData({
          fullName: '',
          phone: '',
          email: ''
        });
      }
    } catch (error) {
      console.error('Ошибка при отправке формы:', error);
      
      if (error.response) {
        const errorData = error.response.data;
        if (errorData.message) {
          setErrors({ general: errorData.message });
        } else {
          setErrors({ general: 'Ошибка при отправке заявки. Попробуйте позже.' });
        }
      } else if (error.request) {
        setErrors({ general: 'Ошибка сети. Проверьте подключение к интернету.' });
      } else {
        setErrors({ general: 'Произошла непредвиденная ошибка' });
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleTelegram = () => {
    window.open('https://t.me/ProTop01123', '_blank');
  };

  if (!checkAuth()) {
    return null;
  }

  return (
    <div className="wrapper">
      <header data-fls-header-accaunt="" className="header-accaunt">
        <div className="header-accaunt__container">
          <div className="header-accaunt__body">
            <a href="/account" className="header-accaunt__logo">
              <img src="/assets/img/logo.svg" alt="Logo" />
            </a>
            <div className="header-accaunt__actions">
              <div className="header-accaunt__settings">
                <a href="/account/setting" className="--icon-settings"></a>
              </div>
              <div className="header-accaunt__profile">
                <a href="" className="--icon-profile">
                  <div className="header-accaunt__content-profile">
                    <span>Профиль</span>
                    <span>Пользователь</span>
                  </div>
                </a>
              </div>
              <button 
                data-fls-button="" 
                type="button" 
                className="header-accaunt__logout header-accaunt__logout--icon-log-out"
                onClick={logout}
              ></button>
            </div>
          </div>
        </div>
      </header>
      <main className="page account">
        <div className="account__container">
          <div className="account__body">
            <nav data-fls-block="" data-fls-aside="" className="aside">
              <ul className="aside__list">
                <li className="aside__item">
                  <a href="/account" className="aside__link aside__link--icon-home">Главная</a>
                </li>
                <li className="aside__item">
                  <a href="/account/expense" className="aside__link aside__link--icon-wallet">Счета</a>
                </li>
                <li className="aside__item">
                  <a href="/account/history" className="aside__link aside__link--icon-history">История</a>
                </li>
                <li className="aside__item">
                  <a href="/account/withdraw" className="aside__link aside__link--icon-withdraw">Вывести</a>
                </li>
                <li className="aside__item">
                  <a href="/account/contact" className="aside__link aside__link--active aside__link--icon-contact">Обратная связь</a>
                </li>
              </ul>
              <div className="aside__actions">
                <a href="/account/withdraw" className="aside__action aside__action--icon-withdraw">Вывести деньги</a>
                <a href="/account/check" className="aside__action aside__action--icon-deposit">Пополнить баланс</a>
              </div>
            </nav>
            <div className="account__content">
              <h3 className="account__title account__title--title-25">Обратная связь</h3>
              <div className="account-contact">
                <form className="account-contact__form" onSubmit={handleCallback}>
                  {errors.general && (
                    <div className="account-contact__error-general">
                      {errors.general}
                    </div>
                  )}
                  {successMessage && (
                    <div className="account-contact__success">
                      {successMessage}
                    </div>
                  )}
                  <div className="account-contact__field">
                    <input
                      required
                      data-fls-input=""
                      autoComplete="off"
                      type="text"
                      name="fullName"
                      value={formData.fullName}
                      onChange={handleInputChange}
                      placeholder="ФИО"
                      className={`input ${errors.fullName ? '--form-error' : ''}`}
                    />
                    {errors.fullName && <div className="account-contact__error-text">{errors.fullName}</div>}
                  </div>
                  <div className="account-contact__field">
                    <div className="account-contact__phone-container">
                      <div className="account-contact__phone-flag">
                        <img src="/assets/img/ru.svg" alt="Flag" />
                      </div>
                      <div className="account-contact__phone-code">
                        <span className="account-contact__country-code">+7</span>
                      </div>
                      <input
                        required
                        data-fls-input=""
                        autoComplete="off"
                        type="tel"
                        name="phone"
                        value={formData.phone}
                        onChange={handlePhoneChange}
                        placeholder="999 999 99 99"
                        className={`account-contact__phone-input ${errors.phone ? '--form-error' : ''}`}
                      />
                    </div>
                    {errors.phone && <div className="account-contact__error-text">{errors.phone}</div>}
                  </div>
                  <div className="account-contact__field">
                    <input
                      required
                      data-fls-input=""
                      autoComplete="off"
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      placeholder="Email"
                      className={`input ${errors.email ? '--form-error' : ''}`}
                    />
                    {errors.email && <div className="account-contact__error-text">{errors.email}</div>}
                  </div>
                  <div className="account-contact__buttons">
                    <button
                      type="submit"
                      data-fls-button=""
                      className="account-contact__button button button--fw"
                      disabled={isLoading}
                    >
                      {isLoading ? 'Отправляем...' : 'Заказать звонок'}
                    </button>
                    <button
                      type="button"
                      data-fls-button=""
                      className="account-contact__button account-contact__button--telegram button button--fw button--border"
                      onClick={handleTelegram}
                    >
                      Связаться в телеграм
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default AccountContact;
